export const getShortUrls = (builder) => ({
    getShortUrls: builder.mutation({
    query: ({pageNumber,limit, from, to, search, category}) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
            return {
                url: `/get_campaign_url_data`, 
                method: 'GET',
                params: {pageNumber,limit, from, to, search, category},
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
            }
        },
    }),
});